<div [formGroup]="formGroup" [class]="data.classStyle">
  <mat-form-field  class="tw-input">
    <input matInput  [placeholder]="data.placeholder" [formControlName]="data.name" >
    <mat-error >
      is <strong>required</strong>
    </mat-error>
  </mat-form-field>
</div>
